/* global approvalProcessList:true */

/**
* Object: approvalProcessDialog
* Purpose:
*/
approvalProcessList = function(id, cui_enabled) {
    'use strict';

    var objApprovalProcessList = list(null, cui_enabled);
    var objDialog = dialog();
    var objDom = dom(cui_enabled);
    var objHermes = hermes();

    /* To extend and modify a parent's function
    objApprovalProcessDialog.pageList = function() {

    }
    */


    objApprovalProcessList.validateNewAP = function() {
        var msg = 'A name is required.';
        $.validity.start();
        $('#curriculog-dialog-new-process-name').require(msg).match(/\w+/, msg);
        var result = $.validity.end();
        return result.valid;
    };

    /*
    * Function: newProcess
    * Purpose: clones a section (header with add row button) from fields.html.php and inserts it into the DOM above the "Add Section" button
    */
    objApprovalProcessList.newApprovalProcess = function(callback) {
        var dialog = objDialog.createDOMDialog('new-process-dialog', function(dialog, defaults) {
            // Actions
            defaults.buttons = {
                'Create New Process': function() {

                    if (objApprovalProcessList.validateNewAP())
                    {
                        $('#curriculog-new-process-name').val($('#curriculog-dialog-new-process-name').val());
                        $('#curriculog-new-process-legends').val($('#curriculog-dialog-new-process-legends').val());
                        $('#curriculog-new-process-type').val($('#curriculog-dialog-new-process-type').val());
                        $('#curriculog-new-process-status').val('unlaunched');

                        var importRequiredCheckbox = $('#curriculog-dialog-new-import-required');
                        if (importRequiredCheckbox.length) {
                            var checkboxVal = importRequiredCheckbox.prop('checked') ? 1 : 0;
                            $('#curriculog-new-import-required').val(checkboxVal);
                        } else {
                            $('#curriculog-new-import-required').val(0);
                        }

                        var sisIdEnabledCheckbox = $('#curriculog-dialog-new-sis-id-enabled');
                        if (sisIdEnabledCheckbox.length) {
                            var checkboxVal = sisIdEnabledCheckbox.prop('checked') ? 1: 0;
                            $('#curriculog-new-sis-id-enabled').val(checkboxVal);
                        } else {
                            $('#curriculog-new-sis-id-enabled').val(0);
                        }

                        $(this).dialog('close');
                        objDom.addLoadingMask('body');
                        if (callback && callback()) {
                            callback.call();
                        }
                    }
                },
                Cancel: function() {
                    $(this).dialog('close');
                }
            };
            defaults.open = function() {
                $('#curriculog-dialog-new-process-type').change(function(event){
                    var currentType = $(this).val();
                    if (currentType === 'other') {
                        $('#curriculog-dialog-new-import-required').prop('checked', false);
                        $('#curriculog-dialog-new-import-required').attr('disabled', true);
                        $('#curriculog-dialog-new-sis-id-enabled').prop('checked', false);
                        $('#curriculog-dialog-new-sis-id-enabled').attr('disabled', true);
                    } else if (currentType === 'program') {
                        $('#curriculog-dialog-new-sis-id-enabled').prop('checked', false);
                        $('#curriculog-dialog-new-sis-id-enabled').attr('disabled', true);
                    } else {
                        $('#curriculog-dialog-new-import-required').removeAttr('disabled');
                        $('#curriculog-dialog-new-sis-id-enabled').removeAttr('disabled');
                    }
                });
            };

            defaults.close = function() {
                $('#curriculog-dialog-process-type').off('change');
            };
            $(dialog).dialog(defaults);
        });
    };

    /*
    * Function: copyApprovalProcess
    * Purpose:
    */
    objApprovalProcessList.copyApprovalProcess = function(item, hermes, callback) {
        var apListItem = $(item).closest('.open-summary');
        var itemId = apListItem.attr('id').substring(7);
        var apType = apListItem.data('ap-type');
        new Curriculog.Dialog({
            el: $('#copy-process-dialog').clone(),

            events: {
                dialogopen: 'toggleCheckboxes'
            },

            buttons: {
                'Copy Process': 'copy',
                'Cancel': 'close'
            },

            selectors: {
                name: '#curriculog-dialog-copy-process-name',
                copyLegendsValue: '#curriculog-dialog-copy-process-legends',
                newID: '#curriculog-new-process-id',
                newName: '#curriculog-new-process-name',
                newStatus: '#curriculog-new-process-status',
                copyLegendsHiddenValue: '#curriculog-new-process-legends',
                importRequiredDialogValue: '#curriculog-dialog-import-required',
                importRequiredValue: '#curriculog-new-import-required',
                sisIdEnabledDialogValue: '#curriculog-dialog-copy-sis-id-enabled',
                sisIdEnabledValue: '#curriculog-new-sis-id-enabled'
            },

            copy: function () {
                if (!this.isValid()) {
                    return;
                }
                this.setFormValues();
                this.close();

                objDom.addLoadingMask('body');
                if (callback && callback()) { // Wat?
                    callback.call();
                }
            },

            isValid: function () {
                var msg = 'A name is required.';
                $.validity.start();
                this.$(this.selectors.name)
                .require(msg)
                .match(/\w+/, msg);
                return $.validity.end().valid;
            },

            setFormValues: function () {
                var name = this.$(this.selectors.name).val();
                var copyLegendsValue = this.$el.find(this.selectors.copyLegendsValue).is(':checked') ? 1 : 0;
                var importRequiredValue = this.$el.find(this.selectors.importRequiredDialogValue).prop('checked') ? 1 : 0;
                var sisIdEnabledValue = this.$el.find(this.selectors.sisIdEnabledDialogValue).prop('checked') ? 1 : 0;


                $(this.selectors.newID).val(itemId);
                $(this.selectors.newName).val(name);
                $(this.selectors.copyLegendsHiddenValue).val(copyLegendsValue);
                $(this.selectors.newStatus).val('unlaunched');
                $(this.selectors.importRequiredValue).val(importRequiredValue);
                $(this.selectors.sisIdEnabledValue).val(sisIdEnabledValue);
            },

            toggleCheckboxes: function() {
                var importRequiredDialogCheckbox = this.$el.find(this.selectors.importRequiredDialogValue);
                var sisIdEnabledDialogCheckbox = this.$el.find(this.selectors.sisIdEnabledDialogValue);

                if (apType === 'other' && importRequiredDialogCheckbox.length) {
                    importRequiredDialogCheckbox.prop('checked', false);
                    importRequiredDialogCheckbox.attr('disabled', true);
                } else if (importRequiredDialogCheckbox.length) {
                    importRequiredDialogCheckbox.removeAttr('disabled');
                }
                
                // we check separately because there are scenarios where one checkbox may be visible but not the other
                if ((apType === 'other' || apType === 'program') && sisIdEnabledDialogCheckbox.length) {
                    sisIdEnabledDialogCheckbox.prop('checked', false);
                    sisIdEnabledDialogCheckbox.attr('disabled', true);
                } else if (sisIdEnabledDialogCheckbox.length) {
                    sisIdEnabledDialogCheckbox.removeAttr('disabled');
                }
            }
        });
    };

    /*
    * Function: launchApprovalProcess
    * Purpose:
    */

    objApprovalProcessList.launchApprovalProcess = function(item, hermes) {
        var itemId = $(item).closest('.open-summary').attr('id').substring(7);
        var dialog = $('<div></div>');
        $(dialog).attr('id','curriculog-dialog-deactivate-warning').addClass('curriculog-dialog-notice').attr('title','Launch Approval Process');
        var strHTML = 'Launching this Approval Process will make it active and available as a template to create proposals. ';
        strHTML += 'Once this Approval Process has an active proposal in the system, it cannot be edited until that proposal reaches final approval. ';
        strHTML += 'Are you sure you want to launch this Approval Process?';
        $(dialog).append(strHTML);
        $('#detail-'+itemId).addClass('curriculog-remove-warning-highlight');

        $(dialog).dialog(
            {
                modal: true,
                resizable: false,
                draggable: false,
                'width': 600,
                buttons: {
                    'Launch Approval Process': function() {
                        $('#'+itemId).removeClass('curriculog-remove-warning-highlight');
                        $.ajax({
                            url: '/admin/approvalProcess:' + itemId + '/status',
                            type: 'PUT',
                            data: {status:'active'},
                            complete: function() {
                                objApprovalProcessList.resetList(function() {
                                    if (hermes) {
                                        //objHermes.getLegendStatus();
                                    }
                                });
                            }
                        });
                        $(this).dialog('close');
                    },
                    Cancel: function() {
                        $('#detail-'+itemId).removeClass('curriculog-remove-warning-highlight');
                        $(this).dialog('close');
                    }
                }
        });
    };

    /*
    * Function: deactivateApprovalProcess
    * Purpose:
    */
    objApprovalProcessList.deactivateApprovalProcess = function(item, hermes) {
        var itemId = $(item).closest('.open-summary').attr('id').substring(7);
        var dialog = $('<div></div>');
        $(dialog).attr('id','curriculog-dialog-deactivate-warning').addClass('curriculog-dialog-warning').attr('title','Warning');
        var strHTML = 'Deactivating this approval process will remove it from the list of active approval processes for users to choose from to create new proposals. ';
        strHTML += 'Active proposals already using this process will continue to use it until they are fully approved or cancelled. ';
        strHTML += 'Are you sure you want to deactivate this approval process?';
        $(dialog).append(strHTML);


        $('#detail-'+itemId).addClass('curriculog-remove-warning-highlight');

        $(dialog).dialog(
            {
                modal: true,
                resizable: false,
                draggable: false,
                'width': 600,
                dialogClass: 'curriculog-dialog warning',
                buttons: {
                    'Deactivate Approval Process': function() {
                        $('#detail-'+itemId).removeClass('curriculog-remove-warning-highlight');
                        $.ajax({
                            url: '/admin/approvalProcess:' + itemId + '/status',
                            type: 'PUT',
                            data: {status:'inactive'},
                            complete: function() {
                                objApprovalProcessList.refreshList('', function() {
                                    if (hermes) {
                                        //objHermes.getLegendStatus();
                                    }
                                });
                            }
                        });
                        $(this).dialog('close');
                    },
                    Cancel: function() {
                        $('#detail-'+itemId).removeClass('curriculog-remove-warning-highlight');
                        $(this).dialog('close');
                    }
                }
            }
        );
    };

    /*
    * Function: reactivateApprovalProcess
    * Purpose:
    */
    objApprovalProcessList.reactivateApprovalProcess = function(item, hermes) {
        var itemId = $(item).closest('.open-summary').attr('id').substring(7);
        var dialog = $('<div></div>');
        $(dialog).attr('id','curriculog-dialog-deactivate-warning').addClass('curriculog-dialog-warning').attr('title','Warning');
        var strHTML = 'Reactivating this Approval Process will restore it to the list of active proposals for users to choose from. ';
        strHTML += 'Are you sure you want to reactivate this Approval Process?';
        $(dialog).append(strHTML);

        $('#detail-'+itemId).addClass('curriculog-remove-warning-highlight');

        $(dialog).dialog(
            {
                modal: true,
                resizable: false,
                draggable: false,
                'width': 600,
                dialogClass: 'curriculog-dialog warning',
                buttons: {
                    'Reactivate Approval Process': function() {
                        $('#'+itemId).removeClass('curriculog-remove-warning-highlight');
                        $.ajax({
                            url: '/admin/approvalProcess:' + itemId + '/status',
                            type: 'PUT',
                            data: {status:'active'},
                            complete: function() {
                                objApprovalProcessList.refreshList('', function() {
                                    if (hermes) {
                                    //objHermes.getLegendStatus();
                                    }
                                });
                            }
                        });
                        $(this).dialog('close');
                    },
                    Cancel: function() {
                        $('#detail-'+itemId).removeClass('curriculog-remove-warning-highlight');
                        $(this).dialog('close');
                    }
                }
            }
        );
    };


    objApprovalProcessList.inUse = function(id, hermes) {
        var dialog = objDialog.createBasicWarningDialog(
            'ap-in-user',
            function(dialog, defaults) {
                // Message
                $(dialog).append('This AP has active proposals. Until those proposals have finished, you may not delete this AP. You may set it to inactive until all proposals have completed. Would you like to set this AP to inactive now?');
                // Actions
                defaults.buttons = {
                    'Make Inactive': function() {
                        $.ajax({
                            url: '/admin/approvalProcess:' + id + '/status',
                            type: 'PUT',
                            data: {status:'inactive'},
                            complete: function() {
                                objApprovalProcessList.refreshList('', function() {});
                            }
                        });
                        $(this).dialog('close');
                    },
                    Cancel: function() {
                        $(this).dialog('close');
                        $('#detail-' + id).removeClass('curriculog-remove-warning-highlight');
                    }
                };
                // Cleanup
                defaults.close = function(event, ui) {
                    $(this).remove();
                };
                $(dialog).dialog(defaults);
            }
        );
    };

    /*
    * Function: deleteApprovalProcess
    * Purpose:
    */
    objApprovalProcessList.deleteApprovalProcess = function(item, hermes) {
        var itemId = $(item).closest('.open-summary').attr('id').substring(7);
        $('#detail-'+itemId).addClass('curriculog-remove-warning-highlight');

        var dialog = objDialog.createBasicWarningDialog(
            'delete-ap',
            function(dialog, defaults) {
                $(dialog).append(
                    'Deleting this Approval Process will permanently remove it from Modern Campus Curriculum. ' +
                    'Are you sure you want to delete this Approval Process?'
                );

                defaults.buttons = {
                    'Delete Approval Process': function() {
                        $('#'+itemId).removeClass('curriculog-remove-warning-highlight');
                        $.ajax({
                            url: '/admin/approvalProcess:' + itemId + '.json',
                            type: 'DELETE',
                            data: {status:'delete'},
                            success: function(status){
                                if (parseInt(status.success, 10) === 1) {
                                    objApprovalProcessList.refreshList('', function() {}, true);
                                } else {
                                    objApprovalProcessList.inUse(itemId, null);
                                }
                            }
                        });
                        $(this).dialog('close');
                    },
                    'Cancel': function() {
                        $('#detail-'+itemId).removeClass('curriculog-remove-warning-highlight');
                        $(this).dialog('close');
                    }
                };
                $(dialog).dialog(defaults);
            }
        );
    };

    /*
    * Function: dialogBuilder
    * Purpose:
    */
    var dialogBuilder = function(fieldArray) {
        var strHTML = '<ul class="curriculog-dialog-field-options">';

        for(var i = 0; i <= fieldArray.length; i++) {
            if(fieldArray[i] === 'name') {
                strHTML += '<li>';
                strHTML += '<label for="curriculog-dialog-new-process-name">Process Name</label>';
                strHTML += '<input type="text" name="curriculog-dialog-new-process-name" id="curriculog-dialog-new-process-name">';
                strHTML += '</li>';
            } else if (fieldArray[i] === 'type') {
                strHTML += '<li>';
                strHTML += '<label for="curriculog-dialog-new-process-type">Process Type</label>';
                strHTML += '<select name="curriculog-dialog-new-process-type" id="curriculog-dialog-new-process-type">';
                strHTML += '<option value="course">Course</option>';
                strHTML += '<option value="program">Program</option>';
                strHTML += '<option value="other">Blank</option>';
                strHTML += '</select>';
                strHTML += '</li>';
            }
        }

        strHTML += '</ul>';
        return strHTML;
    };

  objApprovalProcessList.startImportFlyout = function(listItem) {
      var listItem = listItem;
      var apId = listItem.data('id');
      if (listItem.data('import-required') == true) {
          $.ajax({
              url: '/approvalProcess:' + apId + '/ajax/importflyout',
              type: 'GET',
              data: {display: 'importflyout'},
              beforeSend: function() {
                  objApprovalProcessList.unbindImportFlyoutEvents();
                  objDom.addLoadingMask('#curriculog-import-required-column');
              },
              success: function(result) {
                  var hermesInvalid = $(result).filter('#hermes-invalid').val() == 'true';
                  if (!hermesInvalid) {
                      var validLegends = $(result).filter('#valid-legends').val() == 'true';
                      if (validLegends) {
                          var importColumn = $('#curriculog-import-required-column');
                          importColumn.html(result);
                          objApprovalProcessList.bindImportFlyoutEvents(apId);
                          objDom.removeMask('#curriculog-import-required-column');

                      } else {
                        var invalidLegendsDialog = objDialog.createBasicWarningDialog(
                            'no-valid-legends',
                            function(dialog, defaults) {
                                var message = "At least one valid legend is required to create a proposal using this Approval Process. Contact your System Administrator for assistance.";
                                $(dialog).append(message);
                                defaults.buttons = {
                    				'Ok': function() {
                    					$(this).dialog('close');
                    				}
                    			};
                                defaults.close = function() {
                                    objDom.removeMask('#curriculog-import-required-column');
                                    objDom.importRequiredFlyout(listItem);
                                };
                    			$(dialog).dialog(defaults);
                            }
                        );
                      }
                  } else {
                      var hermesInvalidDialog = objDialog.createBasicWarningDialog(
                          'hermes-invalid',
                          function(dialog, defaults) {
                              var message = "Integration Manager is unavailable. Contact your System Administrator for assistance.";
                              $(dialog).append(message);
                              defaults.buttons = {
                                  'Ok': function() {
                                      $(this).dialog('close');
                                  }
                              };
                              defaults.close = function() {
                                  objDom.removeMask('#curriculog-import-required-column');
                                  objDom.importRequiredFlyout(listItem);
                              };
                              $(dialog).dialog(defaults);
                          }
                      );
                  }
              }

          });
      }
  };

  objApprovalProcessList.unbindImportFlyoutEvents = function() {
      $('#search-submit').off();
      if ($('#search-source').data('select2')) {
        $('#search-source').selectWoo('destroy');
      }
  };

  objApprovalProcessList.bindImportFlyoutEvents = function(apId) {
      var apId = apId;
      var apType = $('.search-form').data('ap-type');
      $('#search-submit').click(function(){
          var validation = objApprovalProcessList.validateImportFlyoutSearch();
          if (validation.valid) {
            objApprovalProcessList.searchHermesDatastore(apId, apType);
          }
      });

      if($('#search-course-prefix').is('select')) {
          $('#search-course-prefix').selectWoo({
              theme: 'curriculog'
          });
      }


      $('#search-source').selectWoo({
          theme: 'curriculog'
      });
  };

  objApprovalProcessList.unbindSearchFiltersPagination = function() {
      $('#first-page').off();
      $('#previous-page').off();
      $('#pagination-go').off();
      $('#next-page').off();
      $('#last-page').off();
      $('#search-results-limit').off();
      $('#action-preview').off();
      $('#action-build').off();
  };

  objApprovalProcessList.bindSearchFiltersPagination = function() {
      $('#first-page').click(function() {
          var searchResultsData = $('#import-search-results > ul').eq(0);
          var limit = searchResultsData.data('limit');
          var page = 1;
          objApprovalProcessList.paginateFilterSearch(page, limit);
      });

      $('#previous-page').click(function() {
          var searchResultsData = $('#import-search-results > ul').eq(0);
          var limit = searchResultsData.data('limit');
          var page = searchResultsData.data('page') - 1;
          if (page <= 0) {
              page = 1;
          }
          objApprovalProcessList.paginateFilterSearch(page, limit);
      });

      $('#pagination-go').click(function() {
         var searchResultsData = $('#import-search-results > ul').eq(0);
         var targetPageNumber = $('#search-pagination-number').val();
         var limit = searchResultsData.data('limit');
         objApprovalProcessList.paginateFilterSearch(targetPageNumber, limit);
      });

      $('#next-page').click(function() {
          var searchResultsData = $('#import-search-results > ul').eq(0);
          var limit = searchResultsData.data('limit');
          var page = searchResultsData.data('page') + 1;
          var totalResults = searchResultsData.data('total-results');
          var maxPage = Math.ceil(totalResults / limit);
          if (page > maxPage) {
              page = maxPage;
          }
          objApprovalProcessList.paginateFilterSearch(page, limit);
      });

      $('#last-page').click(function() {
          var searchResultsData = $('#import-search-results > ul').eq(0);
          var limit = searchResultsData.data('limit');
          var totalResults = searchResultsData.data('total-results');
          var maxPage = Math.ceil(totalResults/limit);

          objApprovalProcessList.paginateFilterSearch(maxPage, limit);
      });

      $('#search-results-limit').change(function() {
          var newLimit = $(this).val();
          var searchResultsData = $('#import-search-results > ul').eq(0);
          var page = 1;
          objApprovalProcessList.paginateFilterSearch(page, newLimit);
      });

      $('.action-preview').click(function() {
          var searchResultsData = $('#import-search-results > ul').eq(0);
          var searchParameters = searchResultsData.data('search-parameters');
          var resultItem = $(this).closest('.list-item');
          var datastoreId = resultItem.data('datastore-id');
          var apId = searchParameters['system_id'];
          var legendId = searchParameters['legend_id'];
          objApprovalProcessList.showImportPreview(apId, legendId, datastoreId);
      });

      $('.action-build').click(function() {
         objApprovalProcessList.doProposalBuild($(this));
      });
  };

  objApprovalProcessList.validateImportFlyoutSearch = function() {
      $.validity.start();
      $('#search-source').require();
      return $.validity.end();
  };

  objApprovalProcessList.searchHermesDatastore = function(apId, apType) {
      var searchData = {
          'display': 'importflyoutsearch',
      };
      var selectedSource = $('#search-source').find(':selected');
      var includeImported = $('#search-include-imported').is(':checked');

      var searchParameters = {
          map_id: selectedSource.data('map-id'),
          system_id: apId,
          legend_id: selectedSource.val(),
          include_imported: includeImported,
          type: apType,
          filter: [],
          paginate: {
              'start': 0,
              'end': 20
          }
      };

      if (apType === 'course') {
          var coursePrefix = $('#search-course-prefix').val();
          if (coursePrefix) {
              searchParameters['filter'].push({
                  'Prefix': coursePrefix
              });
          }

          var courseCode = $('#search-course-code').val();
          if (courseCode) {
              searchParameters['filter'].push({
                  'Code': courseCode
              });
          }

          var courseName = $('#search-course-name').val();
          if (courseName) {
              searchParameters['filter'].push({
                  'Name': courseName
              });
          }

      } else if (apType === 'program') {
          if ($('[name=program-type]:checked').val() === 'sharedcores') {
              searchParameters['type'] = 'core';
              searchParameters['filter'].push({
                  'shared-core': 1
              });
          }
          var programName = $('#search-program-name').val();
          if (programName) {
              searchParameters['filter'].push({
                  'Name': $('#search-program-name').val()
              });
          }
      }


      searchData['searchParameters'] = JSON.stringify(searchParameters);
      searchData['page'] = 1;
      searchData['limit'] = 20;
      searchData['systemName'] = selectedSource.data('system-name');
      objApprovalProcessList.doSearchDatastore(apId, searchData);
  };

  objApprovalProcessList.paginateFilterSearch = function(page, limit) {
      var page = page;
      var limit = limit;
      var searchData = {
          'display': 'importflyoutsearch',
      };
      var searchResultsData = $('#import-search-results > ul').eq(0);
      var searchParameters = searchResultsData.data('search-parameters');
      searchParameters['paginate']['start'] = Number(page * limit) - Number(limit);
      searchParameters['paginate']['end'] = Number(page * limit);

      searchData['searchParameters'] = JSON.stringify(searchParameters);
      searchData['page'] = page;
      searchData['limit'] = limit;

      var apId = searchParameters['system_id'];

      objApprovalProcessList.doSearchDatastore(apId, searchData);
  };

  objApprovalProcessList.doSearchDatastore = function(apId, searchData) {
      $.ajax({
          url: '/approvalProcess:' + apId + '/ajax/importflyoutsearch',
          type: 'GET',
          data: searchData,
          beforeSend: function() {
              objApprovalProcessList.unbindSearchFiltersPagination();
              objDom.addLoadingMask('#import-flyout-summary');
          },
          success: function(result) {
              $('#import-search-results').html(result);
              objDom.verticalStretchList();
              objDom.removeMask('#import-flyout-summary');
              objApprovalProcessList.bindSearchFiltersPagination();
          }
      });
  };

  objApprovalProcessList.showImportPreview = function(apId, legendId, datastoreId) {
      var apId = apId;
      var legendId = legendId;
      var datastoreId = datastoreId;
      $.ajax({
          url: '/approvalProcess:' + apId + '/ajax/importflyoutpreview',
          type: 'GET',
          data: {
              legendId: legendId,
              datastoreId: datastoreId,
              display: 'importflyoutpreview'
          },
          beforeSend: function() {
              objApprovalProcessList.unbindImportPreview();
              objDom.addLoadingMask('#import-flyout-summary');
          },
          success: function(result) {

              $('#import-search-results,.search-form').hide();
              $('#import-item-preview').html(result).show();
              objApprovalProcessList.bindImportPreview();
              objDom.removeMask('#import-flyout-summary');
          }
      });
  };

  objApprovalProcessList.buildProposalFromImport = function(data) {
    var data = data;
    $.ajax({
        type: 'POST',
        url: '/gearman-job.json',
        contentType: 'application/json',
        data: JSON.stringify({
            functionName: 'import_from_ap_task',
            workload: {
                'module_name': 'ProposalImport',
                'method_name': 'import_from_ap_task',
                'method_args': {
                    'ap_id':  data['apId'],
                    'legend_id': data['legendId'],
                    'datastore_id': data['datastoreId'],
                    'proposal_name': objApprovalProcessList.generateNewProposalName(),
                    'program_type': data['type'],
                    'hermes_info': {
                        'id': data['datastoreId'],
                        'externalMapId': data['mapId'],
                        'hermesSystem': data['systemName'],
                        'legendId': data['legendId'],
                        'systemItemId':  data['apId']
                    }
                }
            }
        }),

        beforeSend: function () {
            objDom.addLoadingMask('body');
        },

        success: function (results) {
            getBackgroundJobStatus(
                results.jobHandle,
                'body',
                'Building proposal',
                function(result) {
                    console.debug(result);
                    objDom.removeMask('body');
                    var importData = window.app.proposalImportData;
                    window.sessionStorage.setItem('proposalImportData', JSON.stringify(importData));
                    window.location = '/proposal:'+ result.proposalId +'/form';
                },
                function(error) {
                    var taskName = 'show preview with markup';
                    $('#growls').notify(
                        "create",
                        "warning-template",
                        {
                            title: 'Warning',
                            text: 'An error occurred while attempting to ' + taskName + '. Please try again or contact a system administrator.',
                        },
                        {
                            expires: false,
                        }
                    );
                }
            );

        },
            error: function() {
                objDom.removeMask('body');
            }
    });
  };

  objApprovalProcessList.generateNewProposalName = function() {
      var date = new Date()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var year = date.getFullYear()
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var time = hours + ':' + minutes + ' ' + ampm;
      var date = month + "/" + day + "/" + year + ' ' + time;
      var name = 'New Proposal ' + date;
      return name;
  };

  objApprovalProcessList.unbindImportPreview = function() {
    $('.preview-build,.preview-cancel').off('click');
  };

  objApprovalProcessList.bindImportPreview  = function() {
      $('.preview-build').click(function(){
          objApprovalProcessList.doProposalBuild();
      });

      $('.preview-cancel').click(function() {
         $('#import-item-preview').hide();
         $('#import-item-preview').empty();
         $('#import-search-results,.search-form').show();
      });
  };

  objApprovalProcessList.doProposalBuild = function(item) {
      var searchResultsData = $('#import-search-results > ul').eq(0);
      var searchParameters = searchResultsData.data('search-parameters');
      var resultItem;
      var datastoreId;
      if (item) {
          resultItem = item.closest('.list-item');
          datastoreId = resultItem.data('datastore-id');
      } else {
              datastoreId = $('#preview-datastore-id').val();
      }
      var systemName = searchResultsData.data('system-name');
      var hermesData = {
          apId: searchParameters['system_id'],
          legendId: searchParameters['legend_id'],
          datastoreId: datastoreId,
          systemName: systemName,
          mapId: searchParameters['map_id'],
          type: searchParameters['type']
      };
      objApprovalProcessList.buildProposalFromImport(hermesData);
  };

  return objApprovalProcessList;

};
